import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Config from '@/config/app'

VueCookies.config('30d', '', Config.COOKIES.DOMAIN)

Vue.use(VueCookies)
